module.exports = __webpack_public_path__ + "static/img_2505_optimized-77954c675d139f4dfff278d8cd0bdfc7.jpg";